import { iDataSublimacion } from "../../../interfaces/SuperAdmin/Pages/iDataSublimacion";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";

interface RowSublimacionProps {
  sublimacion: iDataSublimacion;
  i: number;
}

export const RowSublimacion: React.FC<RowSublimacionProps> = ({
  sublimacion,
  i,
}) => {
  //Restar 3 horas para concordar con el horario chileno
  const fechaOriginal = new Date(sublimacion.fecha);
  const fechaAjustada = new Date(fechaOriginal);
  fechaAjustada.setHours(fechaOriginal.getHours() - 3);
  return (
    <StyledTableRow>
      <StyledTableCell sx={{ mb: 2 }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {sublimacion.nombres} {sublimacion.apellidos}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {sublimacion.organizacion}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{sublimacion.plan}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{sublimacion.aplicativo}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {sublimacion.creditos_gastados}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{sublimacion.tokens_in}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{sublimacion.tokens_out}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {fechaAjustada.toLocaleString()}
      </StyledTableCell>
    </StyledTableRow>
  );
};
